(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fit-central-rebuild"] && !Shopify.designMode) return;
  try {
    
const fitCentralSizeMap = {
  "28:A": "XSmall",
  "28:B": "XSmall",
  "28:C": "XSmall or Small",
  "28:D": "XSmall or Small",
  "28:DD(E)": "Small",
  "28:DDD(F)": "Small or Medium",
  "30:A": "XSmall",
  "30:B": "XSmall",
  "30:C": "Small",
  "30:D": "Small",
  "30:DD(E)": "Small or Medium",
  "30:DDD(F)": "Medium",
  "30:G": "Medium",
  "30:H": "Medium or Luxe",
  "30:I": "Luxe",
  "32:A": "XSmall",
  "32:B": "XSmall or Small",
  "32:C": "Small or Medium",
  "32:D": "Small or Medium",
  "32:DD(E)": "Small or Medium",
  "32:DDD(F)": "Medium or Luxe",
  "32:G": "Luxe or 1Luxe",
  "32:H": "Luxe or 1Luxe",
  "32:I": "1Luxe or 2Luxe",
  "34:A": "XSmall",
  "34:B": "Small",
  "34:C": "Small or Medium",
  "34:D": "Medium or Luxe",
  "34:DD(E)": "Luxe or 1Luxe",
  "34:DDD(F)": "Luxe or 1Luxe",
  "34:G": "1Luxe",
  "34:H": "1Luxe or 2Luxe",
  "34:I": "2Luxe",
  "36:A": "Small or Medium",
  "36:B": "Small or Medium",
  "36:C": "Medium or Luxe",
  "36:D": "Luxe or 1Luxe",
  "36:DD(E)": "Luxe or 1Luxe",
  "36:DDD(F)": "1Luxe or 2Luxe",
  "36:G": "2Luxe",
  "36:H": "2Luxe or 3Luxe",
  "36:I": "2Luxe or 3Luxe",
  "38:B": "Luxe or 1Luxe",
  "38:C": "Luxe or 1Luxe",
  "38:D": "1Luxe or 2Luxe",
  "38:DD(E)": "1Luxe or 2Luxe",
  "38:DDD(F)": "2Luxe or 3Luxe",
  "38:G": "3Luxe",
  "38:H": "3Luxe or 4Luxe",
  "38:I": "4Luxe",
  "40:B": "1Luxe or 2Luxe",
  "40:C": "1Luxe or 2Luxe",
  "40:D": "2Luxe or 3Luxe",
  "40:DD(E)": "2Luxe or 3Luxe",
  "40:DDD(F)": "3Luxe or 4Luxe",
  "40:G": "3Luxe or 4Luxe",
  "40:H": "4Luxe or 5Luxe",
  "40:I": "5Luxe",
  "42:B": "1Luxe or 2Luxe",
  "42:C": "2Luxe or 3Luxe",
  "42:D": "3Luxe or 4Luxe",
  "42:DD(E)": "3Luxe or 4Luxe",
  "42:DDD(F)": "3Luxe or 4Luxe",
  "42:G": "4Luxe or 5Luxe",
  "42:H": "5Luxe",
  "42:I": "5Luxe or 6Luxe",
  "44:C": "3Luxe or 4Luxe",
  "44:D": "3Luxe or 4Luxe",
  "44:DD(E)": "4Luxe or 5Luxe",
  "44:DDD(F)": "4Luxe or 5Luxe",
  "44:G": "5Luxe or 6Luxe",
  "44:H": "5Luxe or 6Luxe",
  "44:I": "6Luxe",
  "46:C": "5Luxe",
  "46:D": "5Luxe or 6Luxe",
  "46:DD(E)": "5Luxe or 6Luxe",
  "46:DDD(F)": "5Luxe or 6Luxe",
  "46:G": "6Luxe",
  "46:H": "6Luxe",
  "46:I": "6Luxe",
  "48:C": "6Luxe",
  "48:D": "6Luxe",
  "48:DD(E)": "6Luxe",
  "48:DDD(F)": "6Luxe",
  "48:G": "6Luxe",
  "48:H": "6Luxe",
  "48:I": "6Luxe",
  "50:D": "6Luxe",
  "50:DD(E)": "6Luxe",
  "50:DDD(F)": "6Luxe",
  "50:G": "6Luxe",
  "50:H": "6Luxe",
  "50:I": "6Luxe"
};
function setupFitCentral(root) {
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const product = root.querySelector('#fc-product');
  const units = root.querySelector('#fc-units');
  const charts = [...root.querySelectorAll('.fc-chart')];
  const messages = root.querySelector('[data-fc-messages]').dataset;
  const viewChart = root.querySelector('[data-fc-view-chart]');
  function chooseChart(key, scroll) {
    charts.forEach(chart => { chart.open = chart.id === 'fc-chart-' + key; });
    product.value = key;
    if (viewChart) viewChart.href = '#fc-chart-' + key;
    root.querySelector('#fc-bra-estimator').hidden = key !== 'ultimate';
    if (scroll) root.querySelector('#fc-chart-' + key).scrollIntoView({ block: 'start', behavior: 'instant' });
  }
  product.addEventListener('change', () => {
    chooseChart(product.value, false);
    const selected = root.querySelector('#fc-chart-' + product.value);
    selected.parentElement.prepend(selected);
    if (window.matchMedia('(max-width: 700px)').matches) {
      requestAnimationFrame(() => {
        selected.scrollIntoView({ block: 'start', behavior: 'instant' });
        selected.querySelector('summary').focus({ preventScroll: true });
      });
    }
  });
  charts.forEach(chart => chart.addEventListener('toggle', () => {
    if (!chart.open) return;
    const key = chart.id.replace('fc-chart-', '');
    if (product.value !== key) chooseChart(key, false);
  }));
  units.addEventListener('change', () => {
    const cm = units.value === 'cm';
    root.querySelectorAll('[data-fc-in]').forEach(cell => { cell.textContent = cm ? cell.dataset.fcCm : cell.dataset.fcIn; });
    root.querySelectorAll('[data-fc-unit-label]').forEach(label => { label.textContent = cm ? messages.cm : messages.in; });
  });
  root.querySelectorAll('a[href^="#fc-chart-"]').forEach(link => link.addEventListener('click', () => {
    chooseChart(link.getAttribute('href').replace('#fc-chart-', ''), false);
  }));
  const form = root.querySelector('#fc-estimate-form');
  const result = root.querySelector('.fc-result');
  form.addEventListener('change', () => { result.hidden = true; });
  form.addEventListener('submit', event => {
    event.preventDefault();
    if (!form.reportValidity()) return;
    const key = root.querySelector('#fc-band').value + ':' + root.querySelector('#fc-cup').value;
    const size = fitCentralSizeMap[key];
    root.querySelector('[data-fc-result]').textContent = size || messages.noMatch;
    root.querySelector('[data-fc-two]').hidden = !size || !/ or |\//.test(size);
    result.hidden = false;
  });
  const hash = window.location.hash.replace('#fc-chart-', '');
  if (charts.some(chart => chart.id === 'fc-chart-' + hash)) chooseChart(hash, false);
}
document.querySelectorAll('[data-fit-central]').forEach(setupFitCentral);
document.addEventListener('shopify:section:load', event => setupFitCentral(event.target.querySelector('[data-fit-central]')));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.transparent = this.hasAttribute("data-transparent");
      this.sticky = this.hasAttribute("data-sticky");
      this.selectors = {
        announcementBar: ".shopify-section-announcement-bar",
      };
      this.announcementBarheight = 0;

      this.transparent && document.body.classList.add('transparent-header')
    }

    connectedCallback() {
      ["scroll", "load", "resize"].forEach((event) =>
        window.addEventListener(event, (event) => {
          this.updateHeaderOffsetVariables();
          this.handleTransparent();
          this.checkOverflowSubmenus();
          if(this.transparent) this.offsetMainContent();
        })
      );

      if (this.hasAttribute('data-design-mode') && this.transparent) {
        window.addEventListener('shopify:section:load', (event) => {
          document.querySelector('#MainContent').style.marginTop = 0;

          // delay until styles are loaded
          setTimeout(() => {
            this.offsetMainContent();
          }, 1000);
          return;
        })
      }

      if (!this.transparent) return;
      this.offsetMainContent();
    }

    offsetMainContent() {
      document.querySelector(
        "#MainContent"
      ).style.marginTop = `-${this.offsetHeight  * 0.1}rem`;
    }

    handleTransparent() {
      const transparentAndSticky = this.transparent && this.sticky
      if (!transparentAndSticky) return;
      this.classList.toggle(
        "is-transparent",
        window.scrollY <= this.announcementBarHeight
      );
    }

    updateHeaderOffsetVariables() {
      const announcementBar = document.querySelector(
        this.selectors.announcementBar
      );
      this.announcementBarHeight = announcementBar
        ? announcementBar.offsetHeight
        : 0;
      const headerHeight = this.transparent ? 0 : this.offsetHeight;
      const headerOffset = this.announcementBarHeight + headerHeight;
      // Header height regardless of whether it's transparent or not.
      const transparentHeaderOffset = this.announcementBarHeight + this.offsetHeight;

      document.documentElement.style.setProperty(
        "--header-offset",
        `${headerOffset * 0.1}rem`
      );

      document.documentElement.style.setProperty(
        "--header-offset-with-transparent",
        `${transparentHeaderOffset * 0.1}rem`
      );

      const headerBottomPosition = this.getBoundingClientRect().bottom * 0.1;
      document.documentElement.style.setProperty(
        "--header-dropdown-max-height",
        `calc(100vmin - ${headerBottomPosition}rem)`
      );
    }

    checkOverflowSubmenus() {
      const containerBounderie =
        this.querySelector('[data-container]').getBoundingClientRect().width;

      this.querySelectorAll('[data-nav-sublinks]').forEach(submenu => {
        submenu.closest('[data-nav-dropdown]').classList.remove('is-overflowing');
        const [submenuLeft, submenuRight] = [
          submenu.getBoundingClientRect().left,
          submenu.getBoundingClientRect().right
        ];
        const submenuIsOverflowing =
          submenuLeft > containerBounderie || submenuRight > containerBounderie;
        if (submenuIsOverflowing) {
          submenu.closest('[data-nav-dropdown]')
            .classList.add('is-overflowing')
        }
      })
    }
  }

  customElements.define("sticky-header", StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
